<template>
  <section id="download" class="download">
    <div class="container download-content">
      <h2>{{ t('download.title') }}</h2>
      <p>{{ t('download.subtitle') }}</p>
      <div class="download-buttons">
        <a href="#" class="dl-btn windows">
          <IconSvg name="shield" class="btn-icon" />
          <span>{{ t('download.pc') }}</span>
        </a>
        <a href="#" class="dl-btn android">
          <IconSvg name="shield" class="btn-icon" />
          <span>{{ t('download.android') }}</span>
        </a>
        <a href="#" class="dl-btn ios">
          <IconSvg name="shield" class="btn-icon" />
          <span>{{ t('download.ios') }}</span>
        </a>
      </div>
      <span class="hint">{{ t('download.hint') }}</span>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import IconSvg from './IconSvg.vue'

const { t } = useI18n()
</script>

<style scoped>
.download {
  padding: 6rem 0;
  background: linear-gradient(135deg, #1a0505 0%, #3a0a0a 100%);
  color: #fff;
  text-align: center;
}
.download-content h2 {
  font-size: clamp(2rem, 5vw, 2.75rem);
  margin-bottom: 0.75rem;
}
.download-content p {
  color: rgba(255,255,255,0.75);
  font-size: 1.1rem;
  margin-bottom: 2.5rem;
}
.download-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}
.dl-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.15);
  color: #fff;
  padding: 1rem 1.75rem;
  border-radius: 14px;
  text-decoration: none;
  font-weight: 600;
  transition: transform 0.2s, background 0.2s;
  min-width: 200px;
  justify-content: center;
}
.dl-btn:hover {
  background: rgba(255,255,255,0.18);
  transform: translateY(-3px);
}
.dl-btn.windows {
  background: var(--accent);
  border-color: var(--accent);
}
.dl-btn.windows:hover {
  background: var(--accent-hover);
}
.btn-icon {
  width: 22px;
  height: 22px;
}
.hint {
  color: rgba(255,255,255,0.55);
  font-size: 0.9rem;
}
</style>
